import { Link } from 'react-router-dom';
import { Wordmark } from '../../components/Wordmark';

export function SessionUnavailablePage() {
  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <header className="p-5">
        <Wordmark />
      </header>

      <main className="flex-1 flex items-center justify-center px-4">
        <section className="w-full max-w-md border border-line bg-panel rounded-xl p-7 text-center shadow-md">
          <h1 className="font-display text-2xl text-text mb-3">
            This session is no longer available
          </h1>
          <Link to="/" className="btn btn-accent">
            Back to Home
          </Link>
        </section>
      </main>
    </div>
  );
}
